// extracted by mini-css-extract-plugin
module.exports = {"notificationList":"NotificationList_notificationList__25aoq","fadeIn":"NotificationList_fadeIn__1EUMx","fadeOut":"NotificationList_fadeOut__Epava"};